import axios from "axios";
import { useQuery } from "@tanstack/react-query";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const http = axios.create({ baseURL: API, timeout: 15000 });

const TOKEN = "wlr_token";
export const getToken = () => localStorage.getItem(TOKEN);
export const saveToken = (t) => localStorage.setItem(TOKEN, t);
export const clearToken = () => localStorage.removeItem(TOKEN);
export const authCfg = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });

export const usePlans = () =>
  useQuery({ queryKey: ["plans"], queryFn: async () => (await http.get("/plans")).data });

export const useOffer = () =>
  useQuery({ queryKey: ["offer"], queryFn: async () => (await http.get("/offers/public")).data });

export const useZones = () =>
  useQuery({ queryKey: ["zones"], queryFn: async () => (await http.get("/delivery-zones")).data });

export const formatGBP = (pence) => `£${(pence / 100).toFixed(2)}`;

export const errorMessage = (err) => {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => String(x.msg).replace(/^Value error, /, "")).join(" ");
  if (err?.response?.status === 429) return "Too many requests. Please wait a moment and try again.";
  return "Something went wrong. Please check your connection and try again.";
};
